import * as Types from '../../../../graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

/*
* This was automatically generated on by @graphql-codegen.
* DO NOT MANUALLY EDIT !!!
* Please refer to https://github.com/wistia/wistia/blob/main/frontend/graphql/README.md for more information.
* Last Updated: Wed Nov 05 2025 19:53:47 GMT+0000 (Coordinated Universal Time)
*/

const defaultOptions = {} as const;
export type CreateContactRequestMutationVariables = Types.Exact<{
  input: Types.CreateContactRequestInput;
}>;


export type CreateContactRequestMutation = { __typename?: 'Mutation', createContactRequest?: { __typename?: 'CreateContactRequestPayload', contactRequest: { __typename?: 'ContactRequest', id: string } } | null | undefined };


export const CreateContactRequestDocument = gql`
    mutation CreateContactRequest($input: CreateContactRequestInput!) {
  createContactRequest(input: $input) {
    contactRequest {
      id
    }
  }
}
    `;
export type CreateContactRequestMutationFn = Apollo.MutationFunction<CreateContactRequestMutation, CreateContactRequestMutationVariables>;

/**
 * __useCreateContactRequestMutation__
 *
 * To run a mutation, you first call `useCreateContactRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContactRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContactRequestMutation, { data, loading, error }] = useCreateContactRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateContactRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateContactRequestMutation, CreateContactRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContactRequestMutation, CreateContactRequestMutationVariables>(CreateContactRequestDocument, options);
      }
export type CreateContactRequestMutationHookResult = ReturnType<typeof useCreateContactRequestMutation>;
export type CreateContactRequestMutationResult = Apollo.MutationResult<CreateContactRequestMutation>;
export type CreateContactRequestMutationOptions = Apollo.BaseMutationOptions<CreateContactRequestMutation, CreateContactRequestMutationVariables>;